"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUrlEnvKey = createUrlEnvKey;
function createUrlEnvKey(serviceName, urlName) {
  return `CM_${serviceName.toUpperCase()}_${urlName.toUpperCase()}_URL`;
}
